import { ReactNode } from 'react';
import styles from './TopBar.module.scss';

interface TopBarProps {
    /* Content for the left and right cells — the caller composes whatever it
       needs (icon buttons, menus, nothing). The centre always shows the logo. */
    left?: ReactNode;
    right?: ReactNode;
}

const TopBar = ({ left, right }: TopBarProps) => (
    <header className={styles.bar}>
        <div className={styles.slot}>{left}</div>

        <div className={styles.logo}>
            <img src="/logo/logo-horizontal.svg" alt="Aperture Screen AI" />
        </div>

        <div className={`${styles.slot} ${styles.slotEnd}`}>{right}</div>
    </header>
);

export default TopBar;
